module.exports = __webpack_public_path__ + "img/recruit.ab19bc26.svg";